/*!
 * vue-control-interaction-state-controller v0.10.14 
 * (c) 2020 Alex Tkachenko
 * Released under the MIT License.
 */
import { renderSlim } from '@aspectus/vue-utils';

var InteractionStateController = {
  name: 'vue-control-interaction-state-controller',
  inheritAttrs: false,
  props: ['value'],
  data: function data() {
    return {
      interacted: false,
      interacting: false,
      changed: false,
      changing: false
    };
  },
  render: function render(h) {
    return renderSlim(this.$scopedSlots.default({
      interacted: this.interacted,
      interacting: this.interacting,
      changed: this.changed,
      changing: this.changing,
      value: this.value,
      input: this.input,
      focus: this.focus,
      blur: this.blur,
      handlers: {
        input: this.input,
        focus: this.focus,
        blur: this.blur
      }
    }), h);
  },
  methods: {
    interact: function interact(value) {
      if (!this.interacted) {
        this.interacted = true;
      }

      if (this.interacting !== value) {
        this.interacting = value;
      }
    },
    input: function input(event) {
      if (!this.changed) {
        this.changed = true;
      }

      if (this.interacting && !this.changing) {
        this.changing = true;
      }

      this.interact(this.interacting);
      this.$emit('input', event);
    },
    focus: function focus(event) {
      this.interact(true);
      this.$emit('focus', event);
    },
    blur: function blur(event) {
      this.interact(false);
      this.changing = false;
      this.$emit('blur', event);
    }
  }
};

function install(Vue) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? InteractionStateController.name : _ref$name;

  Vue.component(name, InteractionStateController);
}
var main = {
  install: install
};

export default main;
export { InteractionStateController, install };
